/**
 * slugToCamel — F12.N T5.4 helper.
 *
 * Konwersja snake_case → camelCase. Slugi w `system_module_fields` (helper-encje
 * adresy / konta bankowe / ...) sa snake_case (zgodne z nazwa kolumny PG), ale
 * API response /api/addresses zwraca pola w camelCase (Drizzle ORM mapowanie).
 * Helper laczy oba swiaty w dynamic renderer.
 *
 * Przyklady:
 *   slugToCamel('kind') === 'kind'
 *   slugToCamel('is_primary') === 'isPrimary'
 *   slugToCamel('postal_code') === 'postalCode'
 */
export function slugToCamel(slug: string): string {
  return slug.replace(/_([a-z0-9])/g, (_, ch: string) => ch.toUpperCase());
}
